
/** Contains the open modal dialogs */
const MODALS: { [selector: string]: Modal } = { }


/** Opens a modal dialog */
export function openModal(selector: string) {
    const shade = document.querySelector(selector) as HTMLElement;
    if(shade == null) {
        return;
    }

    let modal = MODALS[selector];
    if(modal == null) {
        modal = new Modal(shade);
        MODALS[selector] = modal;
    }

    modal.open();
}


/** Closes a modal dialog */
export function closeModal(selector: string) {
    const shade = document.querySelector(selector) as HTMLElement;
    if(shade == null) {
        return;
    }

    let modal = MODALS[selector];
    if(modal == null) {
        return;
    }

    modal.close();
    delete MODALS[selector];
}


/** Controls a single modal dialog box */
class Modal {

    constructor(
        public readonly shade: HTMLElement
    ) {
        this.box = shade.querySelector('.slc-modal');
        if(document.body.clientWidth < 950) {
            this.closeButton = shade.querySelector('.slc-mobile-modal-close').querySelector('.slc-modal-close');
        } else {
            this.closeButton = shade.querySelector('.slc-modal-close');
        }
    }

    /** The shade click event listener */
    private shadeClickListener: any;

    /** The box click event listener */
    private boxClickListener: any;

    /** The close button listener */
    private closeButtonListener: any;

    /** The modal box element */
    private box: HTMLElement;

    /** The close button element */
    private closeButton: HTMLElement;

    /** The time animations start */
    private animateStart: number;


    /** Opens the modal */
    public open() {
        this.shade.classList.add('visible');
        document.body.classList.add('modal-lock');
        document.documentElement.classList.add('modal-lock');

        const self = this;

        this.shadeClickListener = function() {
            self.close();
        };
        this.shade.addEventListener('click', this.shadeClickListener);

        this.closeButtonListener = function() {
            self.close();
        };
        this.closeButton.addEventListener('click', this.closeButtonListener);

        this.boxClickListener = function(ev: MouseEvent): any {
            ev.stopPropagation();
        };
        this.box.addEventListener('click', this.boxClickListener);

        this.shade.scrollTop = 0;

        this.animateOpen(200);
    }

    /** Animates opening open */
    private animateOpen(animationDuration: number) {
        if(this.animateStart == null) {
            this.animateStart = Date.now();
        }

        requestAnimationFrame(() => {
            const duration = Date.now() - this.animateStart;

            let percent = duration / animationDuration;
            if(percent >= 1) {
                percent = 1;
            }

            this.box.style.opacity = `${percent}`;
            // this.box.style.transform = `translateY(${(1 - percent)*40}px)`;

            this.shade.style.backgroundColor = `rgba(0, 0, 0, ${0.5*percent})`;

            if(percent < 1) {
                this.animateOpen(animationDuration);
            } else {
                this.animateStart = null;
            }
        });
    }


    /** Closes the modal */
    public close() {
        this.shade.removeEventListener('click', this.shadeClickListener);
        this.closeButton.removeEventListener('click', this.closeButtonListener);
        this.box.removeEventListener('click', this.boxClickListener);

        this.animateClose(200, () => {
            this.shade.classList.remove('visible');
            document.body.classList.remove('modal-lock');
            document.documentElement.classList.remove('modal-lock');
        });
    }

    /** Animates closing */
    private animateClose(animationDuration: number, done?: Function) {
        if(this.animateStart == null) {
            this.animateStart = Date.now();
        }

        requestAnimationFrame(() => {
            const duration = Date.now() - this.animateStart;

            let percent = duration / animationDuration;
            if(percent >= 1) {
                percent = 1;
            }

            this.box.style.opacity = `${1 - percent}`;
            // this.box.style.transform = `translateY(${-1*(percent)*40}px)`;

            this.shade.style.backgroundColor = `rgba(0, 0, 0, ${0.5*(1-percent)})`;

            if(percent < 1) {
                this.animateClose(animationDuration, done);
            } else {
                this.animateStart = null;
                if(done) {
                    done.call(this);
                }
            }
        });
    }

}
